import InformationCircleSVG from 'images/information-circle.svg'

export const InformationCircle = () => (
  <div>
    <InformationCircleSVG />
  </div>
)
